import { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { FaStar } from "react-icons/fa";
import { CDN_BASE_URL } from "config";
import { priceComma } from "utils/priceComma";
import { FaAngleDown, FaAngleUp, FaHeart } from "react-icons/fa6";
import { Heart } from "iconsax-react";
import { FavoriteContext } from "context/FavoriteContext";

const ProductCard = ({ t, data }) => {
  const [showMore, setShowMore] = useState(false);
  const { favorite, setfavorite } = useContext(FavoriteContext);

  const formatDesc = (text) => {
    if (!text) return "";
    return text.replace(/\n/g, "<br />");
  };

  const isFavorite = favorite.find((item) => item.url === data?.url);

  function handleAddFavorite(e) {
    e.preventDefault();
    if (isFavorite) {
      const newCart = favorite.filter((c) => c.url !== data.url);

      setfavorite(newCart);
    } else {
      setfavorite((cur) => [...cur, data]);
    }
  }

  const discountAmount =
    data?.minPrice && data?.minSpecialPrice
      ? data.minPrice - data.minSpecialPrice
      : 0;

  return (
    <Link
      to={`/product/${data?.url}`}
      className="rounded-[12px] border bg-white p-2 block shadow"
    >
      <div className="flex flex-col gap-2 hover_btn">
        <span className="relative">
          <Heart
            onClick={handleAddFavorite}
            className="absolute top-1 right-1"
            size={20}
            color={isFavorite ? "red" : "#000"}
            variant={!isFavorite ? "Linear" : "Bold"}
          />
          <img
            src={CDN_BASE_URL + data?.cover}
            className="w-full object-contain rounded-[8px] h-[175px] md:h-[250px]"
            alt="Product"
          />
        </span>

        <div className="px-2">
          <p className="font-bold text-[16px] text-black text-left">
            {data?.subCategory?.name}
          </p>
          <h3 className="lg:text-[18px] text-black text-left mt-2">
            {data?.name}
          </h3>
          <div className="flex gap-0.5">
            {[...Array(5)].map((_, index) => (
              <FaStar
                key={index}
                className={`text-[16px] ${
                  index < data?.rate ? "text-yellow-400" : "text-gray-300"
                }`}
              />
            ))}
            ({data?.reviews?.length})
          </div>

          {/* Description with Show More / Show Less */}
          <div className="text-[12px] flex flex-col gap-1 text-[#444] mt-2">
            <div
              className={`${!showMore ? "truncate-lines-1" : ""}`}
              dangerouslySetInnerHTML={{
                __html: formatDesc(data?.desc || ""),
              }}
            />
            {data?.desc && (
              <button
                type="button"
                className="font-bold text-left text-[14px] mt-1 flex items-center gap-1"
                onClick={(e) => {
                  e.preventDefault();
                  setShowMore(!showMore);
                }}
              >
                {showMore ? "Show Less" : "Show More"}{" "}
                {showMore ? <FaAngleUp /> : <FaAngleDown />}
              </button>
            )}
          </div>

          {/* Pricing Section */}
          <div className="mt-3">
            {data?.minSpecialPrice ? (
              <div className="flex flex-col items-start gap-0">
                {/* قیمت خط خورده */}
                <div className="text-[16px] text-gray-600 line-through">
                  {priceComma(data?.minPrice, 2)} AED
                </div>
                {/* قیمت تخفیف دار */}
                <div className="text-[18px] text-black font-bold flex items-center flex-wrap justify-between w-full gap-2">
                  {priceComma(data?.minSpecialPrice, 2)} AED
                  {/* مقدار صرفه جویی */}
                  {discountAmount > 0 && (
                    <span className="bg-red-500 text-white text-[14px] rounded-l-[40px] px-3 ml-auto py-1">
                      Save AED {priceComma(discountAmount, 1)}
                    </span>
                  )}
                </div>
              </div>
            ) : (
              <div className="font-bold text-[18px] text-black">
                {priceComma(data?.minPrice, 2)} AED
              </div>
            )}
          </div>
        </div>

        <button className="block w-full bg-red-500 p-2 text-center rounded-[8px] text-white duration-200 mt-2">
          {t("about-btn")}
        </button>
      </div>
    </Link>
  );
};

export default ProductCard;
